import { Component, input, output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MassNotificationTemplateGroup } from '@app/modules/communications/store/communications';
import { TranslatePipe } from '@ngx-translate/core';

interface TemplateGroupItemAction {
  icon: string;
  tooltip: string;
  onClick: () => void;
}

@Component({
  selector: 'topo-template-group-crud-item',
  imports: [MatTooltipModule, TranslatePipe],
  templateUrl: './template-group-crud-item.component.html',
  styleUrl: './template-group-crud-item.component.scss'
})
export class TemplateGroupCRUDItemComponent {
  templateGroup = input.required<MassNotificationTemplateGroup>();

  // all outputs to emit template group
  onDelete = output<MassNotificationTemplateGroup>();
  onCopy = output<MassNotificationTemplateGroup>();
  onEdit = output<MassNotificationTemplateGroup>();

  actions: TemplateGroupItemAction[] = [
    {
      icon: 'icon icon-edit',
      tooltip: 'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATE-GROUP-EDIT',
      onClick: () => this.onEdit.emit(this.templateGroup())
    },
    {
      icon: 'icon icon-delete_trash',
      tooltip: 'MANAGEMENT.COMMUNICATION-CENTER.TEMPLATE-GROUP-DELETE',
      onClick: () => this.onDelete.emit(this.templateGroup())
    }
    // {
    //   icon: 'icon icon-copy_duplicate',
    //   tooltip: '',
    //   onClick: () => this.onCopy.emit(this.templateGroup())
    // }
  ];
}
